import config from '../../config';
import { GraphQLClient } from 'graphql-request';
import logger from '@/logger';
import { store } from '../store';
import { logout } from '../actions/auth.action';

export const makeApolloClient = (state, token) => {
	const auth0Token = token || state.auth.auth0Token;
	return new GraphQLClient(`${config.serverUrl}/graphql/admin`, {
		headers: {
			Authorization: `Bearer ${auth0Token}`,
		},
	});
};

export const arrToObj = (data, formatter, key = 'id') =>
	Array.isArray(data)
		? data.reduce((acc, datum) => {
				formatter ? (acc[datum[key]] = formatter(datum)) : (acc[datum[key]] = datum);
				return acc;
		  }, {})
		: data;

const withoutRequest = ({ response: { status, errors } }) =>
	new Error(errors?.[0]?.message || `Request failed (${status})`);

export const logError = (error, location) => {
	if (error?.response?.status === 401) {
		logger.warn('Invalid or expired token', { location, error });
		store.dispatch(logout());
	} else if (error?.response) {
		const { status, errors } = error.response;
		logger.error(withoutRequest(error), { location, status, errors });
	} else {
		logger.error(error, { location });
	}
	return { error, location };
};

export const absoluteURL = url =>
	url
		.trim()
		.toLowerCase()
		.startsWith('http')
		? url
		: `https://${url}`;

export const checkForDuplicateGroups = (stateDupGroups, groupIDs) => {
	const existingIds = new Set((stateDupGroups || []).map(g => g.id));
	const newGroups = groupIDs.filter(g => !existingIds.has(g.id));
	return newGroups;
};

export const checkForDuplicateItems = (stateDup, id) => stateDup.some(item => item.id === id);

export {
	isSuperAdmin,
	isValidClientAdmin,
	isValidEventAdmin,
	hasSomeRoleInEvent,
	isSaaSAdmin,
	tokenInvalidOrExpired,
} from './auth.util';
export { parseEvent, normalizeEvent } from './event.util';
export { parsePage, normalizePage } from './page.util';
export { parseClient, getAdminClients } from './client.util';
export { socketDisconnectedError, emitWithAck } from './socket.util';
